import React, {useEffect, useState} from "react";
import Styles from './UnwantedSequence/UnwantedSequence.module.scss'
import {buildStyles, CircularProgressbar} from "react-circular-progressbar";
import 'react-circular-progressbar/dist/styles.css';
import {showDuration} from "../../../../../util/util";
import SkippedActivities from "./UnwantedSequence/SkippedActivities";
import Button from "../../../../Componnets/mainButton/Button";
import IsolatedViewPopup from "../IsolatedViewPopup";
const UnwantedSequence = ({card}) => {
    const [showPopup, setShowPopup] = useState(false)

    const sequenceList = []
    if (card?.illegal_edge?.from) {
        sequenceList.push(card.illegal_edge.from)
    }

    if (card?.skipped_activities?.length) {
        card?.skipped_activities?.forEach(item => sequenceList.push(item))
    }

    if (card?.illegal_edge?.to) {
        sequenceList.push(card.illegal_edge.to)
    }

    const handleTriggerShowPopup = () => {
        setShowPopup(!showPopup)
    }

    return (
        <div className="col-12 col-lg-6 col-xl-4">
            <div className={`${Styles.card}`}>
                <div className="d-flex justify-content-between ">
                    <div>
                        <p className="f12 fw500 gray">Unwanted Sequence</p>
                        <p className="f16 fw500 dark-gary-2" title={card.illegal_edge.from}>{card.illegal_edge.from.substring(0,30)}</p>
                        <p className="f12 fw500 gray mt-2">is Followed by</p>
                        <p className="f16 fw500 dark-gary-2" title={card.illegal_edge.to}>{card.illegal_edge.to.substring(0,30)}</p>
                        <div className="d-flex mt-24">
                            {/*<svg  width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                            {/*    <path opacity="0.2" d="M34 17C34 26.3888 26.3888 34 17 34C7.61116 34 0 26.3888 0 17C0 7.61116 7.61116 0 17 0C26.3888 0 34 7.61116 34 17ZM2.97576 17C2.97576 24.7454 9.25463 31.0242 17 31.0242C24.7454 31.0242 31.0242 24.7454 31.0242 17C31.0242 9.25463 24.7454 2.97576 17 2.97576C9.25463 2.97576 2.97576 9.25463 2.97576 17Z" fill="#C485FF"/>*/}
                            {/*    <path d="M29.0208 4.97918C25.8327 1.79107 21.5087 5.37655e-08 17 0V2.97576C20.7195 2.97576 24.2866 4.45331 26.9166 7.08336L29.0208 4.97918Z" fill="#8A0FFF"/>*/}
                            {/*</svg>*/}
                            <div className={Styles.progressCircle}>
                                <CircularProgressbar  value={card.case_coverage * 100} text={''}
                                                      styles={{
                                                          root: {},
                                                          // Customize the path, i.e. the "completed progress"
                                                          path: {
                                                              // Path color
                                                              stroke: '#8a0fff',
                                                              // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                                              strokeLinecap: 'butt',
                                                              // Customize transition animation
                                                              transition: 'stroke-dashoffset 0.5s ease 0s',
                                                              // Rotate the path
                                                              transform: 'rotate(0.0turn)',
                                                              transformOrigin: 'center center',
                                                              strokeWidth:10
                                                          },
                                                          // Customize the circle behind the path, i.e. the "total progress"
                                                          trail: {
                                                              // Trail color
                                                              stroke: '#d6d6d6',
                                                              // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                                              // strokeLinecap: 'butt',
                                                              // Rotate the trail
                                                              // transform: 'rotate(0.25turn)',
                                                              // transformOrigin: 'center center',
                                                          },
                                                          // Rotation of path and trail, in number of turns (0-1)
                                                          rotation: 0,

                                                          // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                                          strokeLinecap: 'butt',

                                                          // How long animation takes to go from one percentage to another, in seconds
                                                          pathTransitionDuration: 0.5,
                                                      }}

                                />
                            </div>

                            <div className={Styles.casesBox}>
                                <p className="f12 fw500 gray">Cases</p>
                                <div className={`d-flex`}>
                                    <p className={`dark-gary-2 f14 fw900`}>{card.cases.length}</p>
                                    <div className={Styles.miniLine}></div>
                                    <p className="dark-gary-2 f14 fw900">{(card.case_coverage * 100).toFixed(2)}%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.rightBox}>
                        <p className={Styles.effectOn}>Effects on</p>
                        <p className="f12 fw400 gray mt-2">Throughput Time</p>
                        <p className={`f14 fw600 dark-gary-2`}>{(card.effect_on_tpt).replace(/shorter|longer/g,'')}</p>
                        <p className="f12 fw400 gray mt-2 disable">Income</p>
                        <p className="f14 fw600 dark-gary-2 disable">- $ 2,561</p>
                        <p className="f12 fw400 gray mt-2">Steps per case</p>
                        <p className={`f14 fw600 dark-gary-2`}>{card.effect_on_steps} Steps</p>
                    </div>
                    {/*<svg  className={Styles.border} width="1" height="187" viewBox="0 0 1 187" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                    {/*    <line x1="0.5" y1="-2.18557e-08" x2="0.500008" y2="187" stroke="#E8EBFF" stroke-dasharray="7 7"/>*/}
                    {/*</svg>*/}
                </div>
                <div className="d-flex mt-3 justify-content-between">
                    <div style={{width: 210}}>
                        <Button
                          type={showPopup && "outlined"}
                          color={showPopup && "primary"}
                          size={"medium"}
                          hoverOutlined
                          block
                          rightArrow
                          onClick={handleTriggerShowPopup}
                        >
                            Make an Isolated View
                        </Button>
                        <IsolatedViewPopup show={showPopup} sequenceList={sequenceList} onTriggerShowPopup={handleTriggerShowPopup} />
                    </div>
                    <SkippedActivities data={card.skipped_activities}/>
                </div>
            </div>
        </div>
    )
};

export default UnwantedSequence;
